import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import axios from "../../axios.jsx";
import BOSForm from "../../components/BOSForm";
import { logout } from "../../Helpers";
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

export default function BOSPanelFormView() {

    const [panelData, setPanelData] = useState({});
    const [fetching, setFetching] = useState(true);
    useEffect(() => {
        if (Cookies.get("username") === undefined) {
            alert("unauthorized to this page")
            logout("/bospanel-login");
            return;
        }
        if (Cookies.get("id") === undefined) {
            alert("Scholar not selected");
            window.location.href= "/bospanels-list";
        }
        fetchData();
    }, []);
    async function fetchData() {
        try {
            let form_data = new FormData();
            form_data.append("scholar_id", Cookies.get("id"));
            const resData = await axios.post("/api/get-bospanel", form_data);
            if (resData.status === 200) {
                setPanelData(resData.data);
                setFetching(false);
            }
            else if (resData.status === 403) {
                alert(resData.Message);
                logout("/bospanel-login");
                return;
            }
        } catch (e) {
            if (e.code === "ERR_BAD_REQUEST") {
                logout("/bospanel-login");
                return;
            }
        }
    }
    return (
        <>
            {!fetching && <BOSForm subjectFromPrev={Cookies.get("username")} viewMode={true} panelData={panelData.panel_data} adjuticatorsData={panelData.adjuticators_data} />}
        </>
    )

}
